export const VENDOR_PATHS = {
  DASHBOARD: "/dashboard",
  NOTIFICHE: "/notifiche",
  NOTIFICHE_VIEW_QUERY: "view",
  NOTIFICHE_VIEW_ARCHIVED: "archived",
  CATALOGO_CSV: "/caricamenti",
  GESTIONE_PRODOTTI: "/prodotti",
  PRODOTTI_CATALOG_QUERY: "catalog",
  RICARICHE: "/gestioneBudget",
  FATTURAZIONE: "/fatturazione",
  DETTAGLIO_MOVIMENTI: "/dettaglioMovimenti",
  RICARICA: "/ricarica",
  TICKET: "/assistenza",
  PROFILO: "/profilo-vendor",
  HISTORY_VENDOR: "/historyVendor",
  DETAIL_ERRORS: "/detailErrors",
  PRIVACY: "/privacy",
  LOGOUT: "/logout",
};

